/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { InventoryResource } from '../models/InventoryResource';

export class DisableResourceOverrideLimitsResponse {
  'updatedResource': InventoryResource;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "updatedResource",
      "baseName": "updatedResource",
      "type": "InventoryResource",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DisableResourceOverrideLimitsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

